import { SxProps, Theme } from "@mui/material";

export const successModalStyles = {
    container: (theme: Theme): SxProps<Theme> => ({
        maxWidth: "680px",
        margin: "0 auto",
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: "20px 12px",
        fontFamily: theme.typography.fontFamily,
    }),
    bookingIdText: (theme: Theme): SxProps<Theme> => ({
        color: "#000",
        fontWeight: 400,
        marginBottom: "8px",
        fontSize: 13,
        fontFamily: theme.typography.fontFamily,
    }),
    headerBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "12px",
        marginBottom: "10px",
    },
    headerMessage: (theme: Theme): SxProps<Theme> => ({
        fontSize: 20,
        fontWeight: 500,
        fontFamily: theme.typography.fontFamily,
    }),
    confirmationText: (theme: Theme): SxProps<Theme> => ({
        color: "#000",
        fontWeight: 400,
        fontSize: 13,
        fontFamily: theme.typography.fontFamily,
    }),
    itemCard: {
        display: "flex",
        flexDirection: "column",
        border: "1px solid #8D8D8D",
        borderRadius: "12px",
        marginTop: "16px",
        marginBottom: "16px",
        backgroundColor: "#fff",
    },
    itemTitle: (theme: Theme): SxProps<Theme> => ({
        fontWeight: 500,
        fontSize: "20px",
        marginTop: "5px",
        color: "#000",
        textAlign: "center",
        padding: "0px 10px",
        fontFamily: theme.typography.fontFamily,
    }),
    dateTimeContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: "5px 7px",
    },
    dateTimeText: (theme: Theme): SxProps<Theme> => ({
        fontSize: "15px",
        color: "#000",
        fontWeight: 400,
        display: "flex",
        alignItems: "center",
        fontFamily: theme.typography.fontFamily,
    }),
    iconStyle: {
        width: "16px",
        marginRight: "5px",
    },
    locationBox: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
    },
    locationIcon: {
        width: "16px",
        marginRight: "8px",
    },
    locationText: (theme: Theme): SxProps<Theme> => ({
        fontSize: "13px",
        color: "#000",
        display: "flex",
        alignItems: "center",
        fontWeight: "400",
        textDecoration: "underline",
    }),
    imageContainer: {
        marginTop: "8px",
        display: "flex",
        justifyContent: "center",
    },
    imageStyle: {
        width: "100%",
        height: "auto",
        maxHeight: "220px",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px",
        objectFit: "fill",
    },
    businessInfoContainer: {
        mt: 3,
    },
    businessInfoHeading: {
        fontSize: "17px",
        fontWeight: 600,
        marginBottom: "8px",
        lineHeight: "22.5px",
        letterSpacing: "0.347px",
    },
    infoRow: {
        display: "flex",
        alignItems: "center",
        marginBottom: "5px",
    },

    webRow: {
        display: "flex",
        alignItems: "center",
    },
    infoIcon: {
        width: "16px",
        height: "16px",
        marginRight: "8px",
    },
    infoText: (theme: Theme): SxProps<Theme> => ({
        fontSize: "15px",
        color: "#000",
        fontWeight: 400,
        textDecoration: "underline",
        fontFamily: theme.typography.fontFamily,
    }),
    infoTextAlt: (theme: Theme): SxProps<Theme> => ({
        fontSize: "14px",
        color: "#000",
        fontWeight: 400,
        textDecoration: "underline",
        fontFamily: theme.typography.fontFamily,
    }),
    webLink: (theme: Theme): SxProps<Theme> => ({
        color: "#000",
        fontWeight: 400,
        fontFamily: theme.typography.fontFamily,
        textDecoration: "underline",
    }),
    horizontalLine: {
        width: "100%",
        height: "1px",
        backgroundColor: "#8D8D8D",
        margin: "16px 0",
    },
    totalPriceContainer: (theme: Theme): SxProps<Theme> => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontFamily: theme.typography.fontFamily,
    }),
    totalPriceLabel: (theme: Theme): SxProps<Theme> => ({
        fontWeight: 600,
        fontSize: "22px",
        fontFamily: theme.typography.fontFamily,
    }),
    totalPriceValue: (theme: Theme): SxProps<Theme> => ({
        fontWeight: 600,
        fontSize: "22px",
        fontFamily: theme.typography.fontFamily,
    }),
    referredByHeading: {
        fontWeight: 600,
        fontSize: "17px",
        marginBottom: "12px",
        color: "#000",
    },
    referrerContainer: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
    },
    referrerAvatar: {
        width: "34px",
        height: "34px",
        objectFit: "contain",
        borderRadius: 20,
    },
    referrerName: {
        fontWeight: 400,
        fontSize: "17px",
        color: "#000",
    },
    referrerMessage: {
        fontSize: "13px",
        fontStyle: "italic",
        marginTop: "5px",
        color: "#000",
        fontWeight: 400,
    },
    footerContainer: {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        marginTop: 10,
    },
    footerText: (theme: Theme): SxProps<Theme> => ({
        fontSize: "13px",
        color: "#000",
        fontWeight: 400,
        fontFamily: theme.typography.fontFamily,
    }),
    footerLogo: {
        width: "80px",
        height: "18px",
    },
};
